import React, { useState } from "react";

const FilterChip = ({ label, onRemove }) => (
    <span className="badge bg-primary d-flex align-items-center">
        {label}
        <button
            type="button"
            className="btn-close btn-close-white ms-2"
            onClick={onRemove}
            style={{ fontSize: "0.6rem" }}
        />
    </span>
);


const FilterSection = ({ filterGroups, selectedFilters, onFilterChange }) => {
    const [selectedPerGroup, setSelectedPerGroup] = useState({});

    // if (!filterGroups?.length) {
    //     return (
    //         <div className="alert alert-info">
    //             Please select a category to load filters
    //         </div>
    //     );
    // }

    return (
        <div>
            <h5 className="border-bottom pb-2 mb-3">
                <i className="bi bi-funnel me-2"></i>
                Filters *
            </h5>

            <div className="row">
                {filterGroups?.length ? filterGroups.map((group) => {
                    const availableFilters = group.filters.filter(
                        (f) => !selectedFilters.includes(f._id)
                    );

                    const appliedFilters = group.filters.filter(
                        (f) => selectedFilters.includes(f._id)
                    );

                    return (
                        <div
                            key={group._id}
                            className="p-3 mb-3 col-4"
                        >
                            <div className="fw-semibold mb-2">
                                {group.name}
                            </div>

                            {/* ADD FILTER */}
                            <div className="d-flex w-100">
                                <select
                                    className="form-select form-select-sm w-100 me-2"
                                    value={selectedPerGroup[group._id] || ""}
                                    onChange={(e) =>
                                        setSelectedPerGroup((prev) => ({
                                            ...prev,
                                            [group._id]: e.target.value
                                        }))
                                    }
                                >
                                    <option value="">+ Add filter</option>
                                    {availableFilters.map((f) => (
                                        <option key={f._id} value={f._id}>
                                            {f.name}
                                        </option>
                                    ))}
                                </select>

                                <button
                                    className="btn btn-sm btn-outline-primary"
                                    disabled={!selectedPerGroup[group._id]}
                                    onClick={() => {
                                        onFilterChange(
                                            selectedPerGroup[group._id],
                                            true
                                        );
                                        setSelectedPerGroup((prev) => ({
                                            ...prev,
                                            [group._id]: ""
                                        }));
                                    }}
                                >
                                    Add
                                </button>
                            </div>

                            {/* SELECTED CHIPS */}
                            <div className="d-flex flex-wrap gap-2">
                                {appliedFilters.length ? (
                                    appliedFilters.map((f) => (
                                        <FilterChip
                                            key={f._id}
                                            label={f.name}
                                            onRemove={() =>
                                                onFilterChange(f._id, false)
                                            }
                                        />
                                    ))
                                ) : (
                                    <small className="text-muted">
                                        No filters selected
                                    </small>
                                )}
                            </div>
                        </div>
                    );
                }) : <div className="alert alert-info">
                    Please select a category to load filters
                </div>}
            </div>
        </div>
    );
};

export default FilterSection;
